const types = {
   CHANGE_PARAMETER: 'CHANGE_PARAMETER',
   CHANGE_MODE: 'CHANGE_MODE',
   RESET_MODE_CHANGED: 'RESET_MODE_CHANGED',
}

export default types
